import md5 from 'js-md5';
import Cookies from 'js-cookie';

function GetPrimaryDomain() {
	const hostname = window.location.hostname;
	const parts = hostname.split('.');

	// 如果是 IP 地址或 localhost，直接返回
	if (parts.length <= 2 || hostname === 'localhost') {
		return hostname;
	}

	return parts.slice(-2).join('.');
}

// 生成浏览器指纹 返回MD5结果
const EVENT_REPORT_KEY = 'event-report-key';
export function GenerateBrowserFingerprint() {
	let localKey = Cookies.get(EVENT_REPORT_KEY);
	if (localKey) {
		return localKey;
	}
	const data = [
		new Date().getTime(),
		navigator.maxTouchPoints,
		navigator.hardwareConcurrency,
		navigator.userAgent,
		screen.colorDepth,
		Array.prototype.map
			.call(navigator.plugins, function (plugin) {
				return [plugin.name, plugin.description];
			})
			.join(',')
	];

	const fingerprint = md5(data.join('###'));
	Cookies.set(EVENT_REPORT_KEY, fingerprint, { domain: GetPrimaryDomain(), path: '/', expires: 365 });

	return fingerprint;
}



// WEBPACK FOOTER //
// ./src/util/init.js